module.exports = __webpack_public_path__ + "img/it-logo-black.8443ae92.svg";